import React from "react";
import styled from "styled-components";

import SafeLink from "components/commons/SafeLink";

import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

const wealthyPartnerIcon = "https://ik.imagekit.io/shadab/Blogs/Group%202614143%20(1).png";
const playStoreIcon = "https://ik.imagekit.io/shadab/Blogs/GooglePlay_toSzDjqnx.png";
const appStoreIcon = "https://ik.imagekit.io/shadab/Blogs/AppStore%20(1).png";

const PartnerAppDownload = () => {
  return (
    <DownloadLink
      href={WealthyEnv.PARTNER_APP_BLOG_ONE_LINK}
      rel="noopener noreferrer"
      target="_blank"
    >
      <AppIcon
        alt="Wealthy Partner App"
        loading="lazy"
        src={wealthyPartnerIcon}
      />
      <Divider />
      <ContentSection>
        <Title>Download Wealthy Partner App</Title>
        <StorePill>
          <StoreOption>
            <StoreIcon
              alt="Apple Store"
              loading="lazy"
              src={appStoreIcon}
            />
            <StoreLabel>Apple Store</StoreLabel>
          </StoreOption>
          <StoreDivider />
          <StoreOption>
            <StoreIcon
              alt="Play Store"
              loading="lazy"
              src={playStoreIcon}
            />
            <StoreLabel>Play Store</StoreLabel>
          </StoreOption>
        </StorePill>
        <StatsRow>
          <StatItem>
            <StarIcon aria-hidden="true" viewBox="0 0 16 16">
              <path d="M8 1.2l1.8 3.65 4.05.59-2.93 2.86.69 4.04L8 10.77l-3.61 1.9.69-4.04L2.15 5.44l4.05-.59L8 1.2z" fill="currentColor" />
            </StarIcon>
            4.6 Rating
          </StatItem>
          <StatDot>•</StatDot>
          <StatItem>
            <DownloadIcon aria-hidden="true" viewBox="0 0 16 16">
              <path d="M8 2v8.17M8 10.17l3-3M8 10.17l-3-3M3 12.5h10" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            </DownloadIcon>
            100k + Downloads
          </StatItem>
        </StatsRow>
      </ContentSection>
    </DownloadLink>
  );
};

const DownloadLink = styled(SafeLink)`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  padding: 1rem;
  margin-bottom: 2rem;
  border: 1px solid #E4E4E4;
  border-radius: 2.4rem;
  background: linear-gradient(to top, #D1C5FF 0%, #F9F9F9 100%);
  box-shadow: 0 0.4rem 2.4rem rgba(103, 37, 244, 0.08);
  text-decoration: none;
  cursor: pointer;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 0.6rem 2.8rem rgba(103, 37, 244, 0.14);
  }
`;

const AppIcon = styled.img`
  flex-shrink: 0;
  width: 7.2rem;
  height: 7.2rem;
`;

const Divider = styled.div`
  flex-shrink: 0;
  width: 1px;
  align-self: stretch;
  background-color: rgba(103, 37, 244, 0.15);
`;

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
`;

const Title = styled.h3`
  font-family: MavenPro;
  font-size: 1.6rem;
  font-weight: 700;
  color: ${colors.textBlack};
  margin: 0;
  line-height: 1.3;
`;

const StorePill = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  padding: 0.4rem 0.8rem;
  border-radius: 999px;
  background-color: ${colors.white};
  box-shadow: inset 0 0.1rem 0.4rem rgba(0, 0, 0, 0.06);
`;

const StoreOption = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.4rem 0.8rem;
`;

const StoreIcon = styled.img`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
`;

const StoreLabel = styled.span`
  font-family: Lato;
  font-size: 1.2rem;
  font-weight: 500;
  color: ${colors.textBlack};
  white-space: nowrap;
`;

const StoreDivider = styled.div`
  width: 1px;
  height: 2rem;
  background-color: ${colors.platinum};
`;

const StatsRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.6rem;
  font-family: Lato;
  font-size: 1.2rem;
  font-weight: 500;
  color: #7C6089;
`;

const StatItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
`;

const StatDot = styled.span`
  color: #7C6089;
`;

const StarIcon = styled.svg`
  width: 1.4rem;
  height: 1.4rem;
`;

const DownloadIcon = styled.svg`
  width: 1.4rem;
  height: 1.4rem;
`;

export default PartnerAppDownload;
